import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as yup from "yup";
import { http } from "../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";

const requestSchema = yup.object({
  ids: yup.array().of(yup.number()).required(),
});

export function useUpdateChartingFilterCategoriesOrderMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(
        HTTP_ENDPOINTS.updateChartingFilterCategoriesOrder(),
        req,
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.chartingFilterCategories],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
